import { useDroppable } from '@dnd-kit/core';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import { Grid, List, Paper } from '@mui/material';
import { ticketType } from 'data/enum';
import useWindowsDimension from 'functions/useWindowsDimension';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { SearchFilter } from './SearchFilter';
import { SortableSingleTicket } from './tickets/SortabeSingleTicket';

export function DroppableTicketList(props: any) {
  const { t } = useTranslation();

  console.log('DroppableTicketList', props.tickets);
  const { setNodeRef } = useDroppable({
    id: props.id,
    data: props.id,
  });

  const {
    id: columnId,
    setActiveTicket,
    tickets,
    handleFilterChange,
    filterType: filterValue,
    handleSearch,
  } = props;
  const list = _.cloneDeep(tickets);

  let navigate = useNavigate();

  const { height } = useWindowsDimension();

  const handleNew = () => {
    navigate('/tickets/new');
  };

  return (
    <>
      <Grid
        ref={setNodeRef}
        item
        xs={12}
        sx={{
          pr: 0,
          m: 0,
          overflowX: 'hidden',
          backgroundColor: 'primary.main',
          borderRadius: 2,
        }}
      >
        <SearchFilter
          Icon={SupportAgentRoundedIcon}
          Header={
            props.id === 'newTickets'
              ? `${t('Ticket.DroppableTicketList.unassignedTickets')}`
              : `${t('Ticket.DroppableTicketList.yourTickets')}`
          }
          filterValue={props.id === 'newTickets' ? filterValue : null}
          handleFilterChange={
            props.id === 'newTickets' ? handleFilterChange : null
          }
          handleSearch={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleSearch(e, props.id)
          }
          handleNew={handleNew}
          selectList={props.id === 'newTickets' ? ticketType : null}
        />

        <List
          sx={{
            height: Math.ceil(height - 252),
            maxHeight: Math.ceil(height - 252),
            width: '100%',
            mb: 0,
            p: 1,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            overflow: 'auto',
          }}
        >
          {tickets?.length === 0 && <div>No data</div>}
          {tickets?.map((ticket: any, index: number) => {
            console.log(
              `Rendering ticket number ${index} in DroppableTicketList:`,
              ticket
            );
            return (
              <SortableSingleTicket
                key={ticket.id}
                id={ticket.id}
                ticket={ticket}
                ticketIndex={index}
                setActiveTicket={setActiveTicket}
                columnId={columnId}
              />
            );
          })}
        </List>

        <Paper
          variant='elevation3'
          sx={{
            p: 2,
            height: 64,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        ></Paper>
      </Grid>
    </>
  );
}
